import React, { useRef } from 'react';

import { Form, message } from 'antd'
import cn from 'classnames';
import omit from 'lodash/omit';
import pick from 'lodash/pick';

import WebsocketKline from '@components/WebsocketKline'
import { I18n } from '@utils/index';

import { useAssetAccountMap0 } from '../hooks/useAssetAccountMap0';
import { ICache, InputAmountField } from './InputAmountField';
import { InputCountField } from './InputCountField';
import { SelectCoinField } from './SelectCoinField';
import { SelectTypeField, TYPE_MAP } from './SelectTypeField';
import { SelectValidPeriod } from './SelectValidPeriod';
import { Affixation, calculateTotalAmount, SubmitBtn } from './SubmitField';
import { useH5SubmitPosition } from './useH5SubmitPosition';
import { FORM_KYYS, useMain } from './useMain';

import styles from './index.module.less';

type IParams = { [key in 'assignType' | 'currency' | 'validTime' | 'num' | 'amount']: string | number }
export interface SendFormProps {
  onSubmit: (params: IParams) => Promise<{ state: 'ok' }>;
  children?: any
}

export const SendForm: React.FC<SendFormProps> = ({ onSubmit, children }) => {
  const { form, rules } = useMain()
  const cacheRef = useRef<ICache>({});
  const assetAccount = useAssetAccountMap0()
  const { divRef, isPosition } = useH5SubmitPosition();
  const onFinish = async (params) => {
    const hotMoney = assetAccount.find(item => item.coinCode === params.currency)?.hotMoney;
    const totalAmount = calculateTotalAmount(form)
    if (totalAmount > Number(hotMoney ?? 0)) {
      message.error(I18n.t('RU3aHpxp'))
      return
    }
    const res = await onSubmit(pick(params, Object.values(FORM_KYYS)));
    const { state } = res || {}
    if (state !== 'ok') return;
    form.resetFields([FORM_KYYS.num, FORM_KYYS.amount]);
    form.setFieldValue(FORM_KYYS.currency, '')
  }

  return (
    <Form
      className={styles.form}
      form={form}
      onFinish={onFinish}
      initialValues={{
        [FORM_KYYS.assignType]: TYPE_MAP.FORTUNE,
        [FORM_KYYS.currency]: '',
        [FORM_KYYS.validTime]: 5,
        [FORM_KYYS.num]: '',
        [FORM_KYYS.amount]: '',
        // 当前所选币种的精度，为附加信息
        precision: 0
      }}>
      <SelectTypeField name={FORM_KYYS.assignType} className={cn(styles.field, styles.test)} />
      <div className={styles.cluster}>
        <SelectCoinField name={FORM_KYYS.currency} className={styles.field} />
        <SelectValidPeriod name={FORM_KYYS.validTime} className={styles.field} />
      </div>
      <InputCountField className={styles.field} name={FORM_KYYS.num} cacheRef={cacheRef} max={rules.releaseNumMax} min={1} />
      <InputAmountField className={styles.field} name={FORM_KYYS.amount} cacheRef={cacheRef} {...omit(rules, 'releaseNumMax')} />
      {children}
      <div className={cn(styles.submit)}>
        <div ref={divRef} className={styles.divRef}>
          <SubmitBtn className={cn(styles.field, {
            [styles.position]: isPosition
          })} />
        </div>
        <Affixation className={cn(styles.field)} />
      </div>
      <WebsocketKline />
    </Form>
  )
}
